<template>
  <KanabanBoard @getMoreData="getNewData" />
</template>

<script>
import kanabanBoarDataProvider from '@/services/kanabanBoard'
import KanabanBoard from './MainBoard.vue'
import { kanbanMixins } from '../../utils/mixins'
export default {
  name: 'kanabanBoard-parent-component',
  mixins: [kanbanMixins],
  components: {
    KanabanBoard,
  },
  data() {
    return {
      // totalPages: 2,
    }
  },
  computed: {
    // pageNumber() {
    //   if (!this.$route.query.pageNumber) {
    //     return 1
    //   } else {
    //     return parseInt(this.$route.query.pageNumber)
    //   }
    // },
  },
  watch: {
    // pageNumber(newValue, oldValue) {
    //   if (oldValue !== newValue) {
    //     this.getKanbanData()
    //     
    //   }
    // },
  },
  methods: {
    getKanbanData() {
      kanabanBoarDataProvider
        .getKanbanData({
          key: this.$route.params.slug,
          pageNumber: 1,
          pageSize: 300,
        })
        .then(res => {
          this.$store.dispatch('kanban/setKanbanData', res.data.data)
        })
        .catch(err => {
          
        })
    },
    // getNewData() {
    //   let pageNumber = this.pageNumber
    //   const route = this.$route.path
    //   // const filter = this.$route.query.filters
    //   this.$router.push({ path: `${route}?pageNumber=${pageNumber + 1}` })
    // },
  },
  mounted() {
    this.getKanbanData()
  },
}
</script>

<style scoped lang="scss"></style>
